<template lang="pug">
  //- outer / margins
  .fixed.inset-0.bg-white.z-40.flex.pt-9vh.pb-12vh.px-24(@mousemove="onMouse", :class="{'cursor-left-arrow': hover === 'left', 'cursor-right-arrow': hover === 'right'}", @click="onClick", ref="viewer", style="touch-action: pan-y")
    //- inset frame — each slide sits in its own track position and slides in following the
    //- drag, Instagram-style, instead of the old opacity/visibility cross-fade
    .relative.z-20.w-full.overflow-hidden(ref="frame")
      //- slides
      viewer-slide.project-viewer__slide(v-for="(slide, i) in slides", :key="i", :slide="slide", :active="active === i", :imgL="imgL", :index="i", :style="trackStyle(i, active, slides.length)")
    //- caption
    .absolute.z-20.w-full.bottom-0.left-0.flex.items-end.p-24.type-caption.tracking-40.bg-white
      .w-1x8
      figcaption.flex-1.text-center
        prismic-rich-text.inline.children-inline.child-bold-text-gray-500(v-if="activeSlide", :field="activeSlide.caption")
      //- count
      .w-1x8.text-right.font-numbers-normal {{active + 1}}&mdash;{{slides.length}}
    //- close btn
    .absolute.z-30.top-0.right-0.p-18
      button.p-12(@click.stop="$store.commit('CLOSE_VIEWER')", aria-label="Close Viewer")
        svg-x.w-16.h-16
</template>

<script>
import ViewerSlide from './ProjectViewer__Slide'
import svgX from '@/components/Icons/SVG-X'
import { mapState } from 'vuex'
import { next } from '@/utils'
import DragTrack from '@/mixins/DragTrack'
import _throttle from 'lodash/throttle'
export default {
  name: 'ProjectViewer',
  mixins: [DragTrack],
  props: ['slides', 'start'],
  data () {
    return {
      active: -1,
      imgL: 0,
      hover: null
    }
  },
  computed: {
    ...mapState(['winH', 'winW', 'viewerAt']),
    activeSlide () {
      return this.slides[this.active]
    }
  },
  methods: {
    next (dir = 1) {
      this.active = next(this.active, dir, this.slides.length)
    },
    setStart () {
      this.active = this.slides.findIndex(slide => slide.id === this.viewerAt)
    },
    onMouse: _throttle(function (e) {
      // event.path was Chrome-only and has been removed, composedPath() is the standard (E4 click-to-enlarge fix)
      const path = e.composedPath ? e.composedPath() : (e.path || [])
      const isVimeoFrame = path.find(el => el.classList && el.classList.value.includes('vimeo-player__frame'))
      const isLeft = e.clientX <= this.winW * 0.5 // assuming overlay is full window
      this.hover = isVimeoFrame ? 'vimeo' : isLeft ? 'left' : 'right'
    }, 100),
    onClick () {
      if (this.swiped) return
      switch (this.hover) {
        case 'left': return this.next(-1)
        case 'right': return this.next(1)
      }
    },
    onKey (e) {
      if (e.key === 'ArrowRight') this.next(1)
      else if (e.key === 'ArrowLeft') this.next(-1)
      else if (e.key === 'Escape') this.$store.commit('CLOSE_VIEWER')
    }
  },
  created () {
    this.setStart()
  },
  mounted () {
    this.imgL = parseInt(this.winH * 0.85)
    window.addEventListener('keydown', this.onKey)
    // swipe or drag through the enlarged photos as well (E2): captured across the whole overlay,
    // measured against the inner frame so the live drag tracks the image itself
    this.bindDragTrack(this.$refs.viewer, {
      widthEl: this.$refs.frame,
      onSwipeLeft: () => this.next(1),
      onSwipeRight: () => this.next(-1)
    })
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKey)
  },
  watch: {
    viewerAt () {
      this.setStart()
    }
  },
  components: { ViewerSlide, svgX }
}
</script>

<style>
</style>
